/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-20 14:49:14
 * @LastEditors: K
 * @LastEditTime: 2022-11-03 11:49:44
 */
import { Row, Col, Form, Checkbox, Button } from 'antd';
import layout from 'antd/lib/layout';
import React, { ReactElement, useEffect } from 'react';
import { Checks } from '../../../../models/setting';
import styles from '../TenantSetting.module.css'
interface BaseSetProps {
  formObj: any
  formChange: () => void
  onSave: (obj: any) => void
}
export const BaseSet = ({
  formObj,
  formChange,
  onSave
}: BaseSetProps): ReactElement => {
  const [form] = Form.useForm()

  useEffect(() => {
    if (!formObj) return
    form.setFieldsValue({
      ...formObj,
    })
  }, [formObj])

  return (
    <div style={{ padding: '0 10px' }}>
      <Form
        // labelAlign='right'
        // initialValues={{ remember: true, [Checks.QF]: 'false' }}
        form={form}
        autoComplete='off'
        onFinish={(values) => {
          onSave(values)
        }}
        onValuesChange={() => formChange()}
      >
        <Row style={{ marginLeft: '60px', marginTop: '20px' }}>
          <Col span={4}>
            <Form.Item {...layout} name={Checks.Zdfy} valuePropName='checked'>
              <Checkbox>自动发药</Checkbox>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item {...layout} name={Checks.Psgl} valuePropName='checked'>
              <Checkbox>皮试管理</Checkbox>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              {...layout}
              name={Checks.Gbxgjg}
              valuePropName='checked'
            >
              <Checkbox>关闭修改价格(医生)</Checkbox>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              {...layout}
              name={Checks.Gbkdysstx}
              valuePropName='checked'
            >
              <Checkbox>关闭医生开关提醒</Checkbox>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item {...layout} name={Checks.Zjjs} valuePropName='checked'>
              <Checkbox>诊间结算</Checkbox>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              {...layout}
              name={Checks.Lkcky}
              valuePropName='checked'
            >
              <Checkbox>零库存开药</Checkbox>
            </Form.Item>
          </Col>

        </Row>
        <Row style={{ marginLeft: '60px', marginTop: '20px' }}>
          <Col span={4}>
            <Form.Item
              {...layout}
              name={Checks.CFJDYCFJE}
              valuePropName='checked'
            >
              <Checkbox>处方笺处方金额打印</Checkbox>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              {...layout}
              name={Checks.CFJDYBZ}
              valuePropName='checked'
            >
              <Checkbox>处方笺打印备注</Checkbox>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              {...layout}
              name={Checks.ZYTFF}
              valuePropName='checked'
            >
              <Checkbox>中药贴敷方</Checkbox>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <div className={styles.btnWrap}>
        <Button onClick={form.submit} type='primary'>
          确认
        </Button>
      </div>
    </div>
  );
}
